
export class Logger{
    public static writeRuleCycleLogs = false;
    public static writeSceneChangeLogs = false;

    public static logRuleStart(configName: string, ruleType: string) {
        if (Logger.writeRuleCycleLogs) {
            let startTime = Date.now();
            if (Logger.writeRuleCycleLogs) {
                console.log(`%cRULE -> ${configName} -> ${ruleType} -> START`, "background: rgba(0,182,255,0.3)");
            }
            return startTime;
        }
    }

    public static logRuleEnd(configName: string, ruleType: string, start: number) {
        if (Logger.writeRuleCycleLogs) {
            let time = Date.now() - start;
            console.log(`%cRULE -> ${configName} -> ${ruleType} -> END  ${time}ms`, "background: rgba(0,85,255,0.3)");
        }
    }

    public static logSceneChange(msg: string) {
        if (Logger.writeSceneChangeLogs) {
            console.log(msg);
        }
    }
}

if (typeof window !== "undefined") {
    try {
        Logger.writeRuleCycleLogs = localStorage.getItem("writeRuleCycleLogs") == "true";
        Logger.writeSceneChangeLogs = localStorage.getItem("writeSceneChangeLogs") == "true";
    } catch {}
}